import React from 'react';

const Home = () => {
  return (
    <div className="container" id="home">
      <h2>Real Estate Analysis: Unveiling Trends and Predicting Prices</h2>
      <p>Welcome to my real estate analysis project! This project dives into the world of property trends and pricing predictions to help individuals and businesses make smarter real estate decisions.</p>
      <p>The purpose of this project is to leverage data analysis and predictive modeling techniques to uncover trends and predict prices in the real estate market.</p>
      <p>Ultimately, the goal is to enhance profitability, competitiveness, and strategic decision-making in the dynamic landscape of real estate.</p>
    </div>
  );
};

export default Home;
